import { MutationFunction, useMutation, UseMutationOptions } from 'react-query';

/**
 * All of our CRUD mutation hooks (loans, prorations, ledger entries, etc.)
 * were hand-written wrappers around `useMutation` that differed only in the
 * mutation function and its return/error/variables types:
 *
 *   export const useX = ({ queryConfig }: Params) =>
 *     useMutation(mutationFn, { ...queryConfig });
 *
 * `createMutationHook` captures that shape once so a new CRUD hook is a
 * one-liner: `export const useX = createMutationHook<XReturn>(mutationFnX);`
 */
type CreateMutationHookParams<TReturn, TError, TVariables> = {
  queryConfig?: UseMutationOptions<TReturn, TError, TVariables, any>;
};

export const createMutationHook = <TReturn, TVariables = any, TError = Error>(
  mutationFn: MutationFunction<TReturn, TVariables>
) => ({ queryConfig }: CreateMutationHookParams<TReturn, TError, TVariables> = {}) =>
    useMutation(mutationFn, { ...queryConfig });
